/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Annual_SuffixInputs */

const en_annual_suffix = /** @type {(inputs: Annual_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/year`)
};

const id_annual_suffix = /** @type {(inputs: Annual_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/tahun`)
};

const ms_annual_suffix = /** @type {(inputs: Annual_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/tahun`)
};

const ca_annual_suffix = /** @type {(inputs: Annual_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/any`)
};

const cs_annual_suffix = /** @type {(inputs: Annual_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/rok`)
};

const da_annual_suffix = /** @type {(inputs: Annual_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/år`)
};

const de_annual_suffix = /** @type {(inputs: Annual_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/jahr`)
};

const et_annual_suffix = /** @type {(inputs: Annual_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/aasta`)
};

const es_annual_suffix = /** @type {(inputs: Annual_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/año`)
};

const fr_annual_suffix = /** @type {(inputs: Annual_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/an`)
};

const hr_annual_suffix = /** @type {(inputs: Annual_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/godina`)
};

const it_annual_suffix = /** @type {(inputs: Annual_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/anno`)
};

const lv_annual_suffix = /** @type {(inputs: Annual_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ gadā`)
};

const lt_annual_suffix = /** @type {(inputs: Annual_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ metai`)
};

const hu_annual_suffix = /** @type {(inputs: Annual_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/év`)
};

const nl_annual_suffix = /** @type {(inputs: Annual_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/jaar`)
};

const nb_annual_suffix = /** @type {(inputs: Annual_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/år`)
};

const pl_annual_suffix = /** @type {(inputs: Annual_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/rok`)
};

const pt_annual_suffix = /** @type {(inputs: Annual_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ano`)
};

const ro_annual_suffix = /** @type {(inputs: Annual_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/an`)
};

const sk_annual_suffix = /** @type {(inputs: Annual_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/rok`)
};

const sl_annual_suffix = /** @type {(inputs: Annual_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/leto`)
};

const fi_annual_suffix = /** @type {(inputs: Annual_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/vuosi`)
};

const sv_annual_suffix = /** @type {(inputs: Annual_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/år`)
};

const vi_annual_suffix = /** @type {(inputs: Annual_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/năm`)
};

const tr_annual_suffix = /** @type {(inputs: Annual_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/yıl`)
};

const el_annual_suffix = /** @type {(inputs: Annual_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/έτος`)
};

const bg_annual_suffix = /** @type {(inputs: Annual_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/година`)
};

const ru_annual_suffix = /** @type {(inputs: Annual_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/год`)
};

const sr_annual_suffix = /** @type {(inputs: Annual_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`годишње`)
};

const uk_annual_suffix = /** @type {(inputs: Annual_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/рік`)
};

const ka_annual_suffix = /** @type {(inputs: Annual_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/წელი`)
};

const hi_annual_suffix = /** @type {(inputs: Annual_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/साल `)
};

const th_annual_suffix = /** @type {(inputs: Annual_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ปี`)
};

const ko_annual_suffix = /** @type {(inputs: Annual_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/연`)
};

const zh_annual_suffix = /** @type {(inputs: Annual_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/年`)
};

const zh_tw_annual_suffix = /** @type {(inputs: Annual_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/年`)
};

const ja_annual_suffix = /** @type {(inputs: Annual_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/年`)
};

/**
* | output |
* | --- |
* | "/year" |
*
* @param {Annual_SuffixInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const annual_suffix = /** @type {((inputs?: Annual_SuffixInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Annual_SuffixInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_annual_suffix(inputs)
	if (locale === "ms") return ms_annual_suffix(inputs)
	if (locale === "ca") return ca_annual_suffix(inputs)
	if (locale === "cs") return cs_annual_suffix(inputs)
	if (locale === "da") return da_annual_suffix(inputs)
	if (locale === "de") return de_annual_suffix(inputs)
	if (locale === "et") return et_annual_suffix(inputs)
	if (locale === "es") return es_annual_suffix(inputs)
	if (locale === "fr") return fr_annual_suffix(inputs)
	if (locale === "hr") return hr_annual_suffix(inputs)
	if (locale === "it") return it_annual_suffix(inputs)
	if (locale === "lv") return lv_annual_suffix(inputs)
	if (locale === "lt") return lt_annual_suffix(inputs)
	if (locale === "hu") return hu_annual_suffix(inputs)
	if (locale === "nl") return nl_annual_suffix(inputs)
	if (locale === "nb") return nb_annual_suffix(inputs)
	if (locale === "pl") return pl_annual_suffix(inputs)
	if (locale === "pt") return pt_annual_suffix(inputs)
	if (locale === "ro") return ro_annual_suffix(inputs)
	if (locale === "sk") return sk_annual_suffix(inputs)
	if (locale === "sl") return sl_annual_suffix(inputs)
	if (locale === "fi") return fi_annual_suffix(inputs)
	if (locale === "sv") return sv_annual_suffix(inputs)
	if (locale === "vi") return vi_annual_suffix(inputs)
	if (locale === "tr") return tr_annual_suffix(inputs)
	if (locale === "el") return el_annual_suffix(inputs)
	if (locale === "bg") return bg_annual_suffix(inputs)
	if (locale === "ru") return ru_annual_suffix(inputs)
	if (locale === "sr") return sr_annual_suffix(inputs)
	if (locale === "uk") return uk_annual_suffix(inputs)
	if (locale === "ka") return ka_annual_suffix(inputs)
	if (locale === "hi") return hi_annual_suffix(inputs)
	if (locale === "th") return th_annual_suffix(inputs)
	if (locale === "ko") return ko_annual_suffix(inputs)
	if (locale === "zh") return zh_annual_suffix(inputs)
	if (locale === "zh-tw") return zh_tw_annual_suffix(inputs)
	if (locale === "ja") return ja_annual_suffix(inputs)
	return en_annual_suffix(inputs)
});